/*
 * @vinejs/vine
 *
 * (c) VineJS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { ValidationError } from './validation_error.js'

/**
 * Create an instance of validation error
 */
export const E_VALIDATION_ERROR = ValidationError
